import Vue      from 'vue'
import Vuex     from 'vuex'
import app     from './app'
import ticket  from './ticket'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app   : { ...app },
    ticket: { ...ticket }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js